import React from "react";
import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./styles/global.css";
import "./styles/navbar.css";
import "./styles/hero.css";
import "./styles/trustbar.css";
import "./styles/whychooseus.css";
import "./styles/ai.css";
import "./styles/process.css";
import "./styles/portfolio.css";
import "./styles/testimonials.css";
import "./styles/service.css";
import "./styles/stats.css";
import "./styles/whatsapp.css";
import "./styles/contact.css";
import "./styles/cta.css";
import "./styles/footer.css";
import "./styles/responsive.css";

import AOS from "aos";
import "aos/dist/aos.css";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

AOS.init({
  duration: 1000,
});
